import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Formik } from 'formik';
import { FormikTextField } from '../../../common/formik-material-ui';
import { useSnackbarWithStyles } from '../../components/notifications/SnackbarProviderWithStyles';
import { ModalWithStyles } from './ModalWithStyles';

const useStyles = makeStyles((theme: Theme) => ({
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
  },
}));

export function EditBillingEmailModal(props) {
  const classes = useStyles();
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  return (
    <Formik
      onSubmit={async (values, actions) => {
        const response = await props.mutation.mutateAsync({
          endpoint: 'legacy/updateStripeBillingEmail',
          payload: {
            email: values.email,
            call: 'updateStripeBillingEmail',
          },
        });

        if (response?.data?.success) {
          enqueueSnackbarWithStyles({
            message: 'Billing email successfully updated',
            alertProps: {
              severity: 'success',
            },
          });
        } else {
          enqueueSnackbarWithStyles({
            message: 'An error occured. Billing email was not updated',
            alertProps: {
              severity: 'error',
            },
          });
        }

        props.setRefetchToggleForStripeBillingEmail({});
        props.handleClose();
      }}
      enableReinitialize={true}
      initialValues={{ selected: props.selected ?? [], email: '' }}
    >
      {(formik) => (
        <ModalWithStyles
          onSubmit={() => {
            formik.handleSubmit();
          }}
          title="Update Billing Email"
          aria-labelledby="example-modal-sizes-title-md"
          show={props.show}
          onHide={props.handleClose}
          isSubmitting={formik.isSubmitting}
          isLoading={formik.isSubmitting}
          submitLabel="Save"
          size="xs"
        >
          <div>
            <FormikTextField
              name="email"
              formik={formik}
              variant="outlined"
              type="email"
              className={classes.field}
              fullWidth
              size="small"
            />
          </div>
          <p> Do you want to proceed?</p>
        </ModalWithStyles>
      )}
    </Formik>
  );
}
